/**
 * Static SEO rules shared by catalog, redirect, and sitemap layers.
 *
 * This module contains no behavior; each consumer applies these data sets.
 */

/** Legacy canonical overrides that existed before both SEO specifications. */
const LEGACY_CANONICAL_MAP = Object.freeze({
  "/dubai-sharjah/female/pakistani-escorts": "/dubai/female/pakistani-escorts",
  "/dubai/male/verified": "/dubai/male",
  "/dubai/female/fingering": "/dubai/female",
  "/transgender/natural-breast": "/dubai/transgender",
  "/transgender/big-ass": "/dubai/transgender",
  "/dubai/transgender/revers-oral": "/dubai/transgender",
  "/transgender/silicone-breast": "/dubai/transgender",
});

/** Second SEO specification: Transgender cluster and female service facets. */
const CANNIBALIZATION_CANONICAL_MAP = Object.freeze({
  "/dubai-jvc/transgender": "/dubai/transgender",
  "/dubai-dubai-marina/transgender": "/dubai/transgender",
  "/dubai-jlt/transgender": "/dubai/transgender",
  "/dubai-deira/transgender": "/dubai/transgender",
  "/dubai-business-bay/transgender": "/dubai/transgender",
  "/dubai/transgender/verified": "/dubai/transgender",
  "/dubai/transgender/blonde-escorts": "/dubai/transgender",
  "/dubai/transgender/filipino-escorts": "/dubai/transgender",
  "/dubai/female/incall-services-escorts": "/dubai/female",
  "/dubai/female/outcall-services-escorts": "/dubai/female",
  "/dubai/female/for-couples-services-escorts": "/dubai/female",
  "/dubai/female/webcam-sex": "/dubai/female",
  "/dubai/female/oral": "/dubai/female",
  "/dubai/female/anal": "/dubai/female",
  "/dubai/female/duo-with-girl": "/dubai/female",
});

/** Latest SEO decision for the Dubai female massage cluster. */
const MASSAGE_CANONICAL_MAP = Object.freeze({
  "/dubai/female/massage": "/dubai/female/erotic-massage",
  "/dubai/female/nuru-massage": "/dubai/female/erotic-massage",
  "/dubai/female/tantric-massage": "/dubai/female/erotic-massage",
});

/**
 * Exact URLs from the second specification's `noindex,follow` section.
 * Consumed by `common/seo/catalog-seo.js`; these rules lock index decisions.
 */
export const FORCE_NOINDEX_PATHS = Object.freeze([
  "/dubai/transgender/com",
  "/dubai/transgender/incall-services-escorts",
  "/dubai/transgender/tie-and-tease",
]);

/**
 * Final exact canonical map for catalog pages.
 * Legacy decisions are preserved; second-specification rules take precedence.
 */
export const CANONICAL_MAP = Object.freeze({
  ...LEGACY_CANONICAL_MAP,
  ...CANNIBALIZATION_CANONICAL_MAP,
  ...MASSAGE_CANONICAL_MAP,
});

/**
 * Second-specification URLs excluded from sitemap: canonical source URLs and
 * pages marked `noindex,follow`.
 */
export const SITEMAP_EXCLUDED_PATHS = Object.freeze([
  ...Object.keys(CANNIBALIZATION_CANONICAL_MAP),
  ...FORCE_NOINDEX_PATHS,
]);

/** Exact homepage Title/H1 from the second SEO specification. */
export const HOME_PAGE_META = Object.freeze({
  title: "Escorts in Dubai — Verified Independent Escorts | EmiratEscort",
  h1: "Dubai Escorts",
});

/** Exact catalog Title/H1 overrides from the second SEO specification. */
export const CATALOG_META_OVERRIDES = Object.freeze({
  "/dubai/female": Object.freeze({
    title: "Female Escorts in Dubai — Verified Profiles",
    h1: "Female Escorts Dubai",
  }),
  "/dubai/transgender": Object.freeze({
    title: "Shemale & TS Escorts in Dubai — Trans Escorts",
    h1: "Trans / Shemale Escorts Dubai",
  }),
  "/dubai/male": Object.freeze({
    title: "Male Escorts in Dubai",
    h1: "Male Escorts Dubai",
  }),
  "/dubai-jvc/female": Object.freeze({
    title: "Female Escorts in JVC, Dubai",
    h1: "Escorts in JVC (Dubai)",
  }),
  "/dubai/female/asian-escorts": Object.freeze({
    title: "Asian Escorts in Dubai",
    h1: "Asian Escorts Dubai",
  }),
  "/dubai/transgender/nuru-massage": Object.freeze({
    title: "Nuru Massage with Trans Escorts in Dubai | EmiratEscort",
  }),
  "/dubai/transgender/tantric-massage": Object.freeze({
    title: "Tantric Massage with Trans Escorts in Dubai | EmiratEscort",
  }),
});

/**
 * Exact URLs allowed to be indexed despite the base catalog rule.
 * This is a legacy index allowlist, not a canonical allowlist.
 */
export const FORCE_INDEX_PATHS = Object.freeze([
  "/dubai-sharjah/female/indian-nationality-escorts",
  "/dubai-sharjah/female/pakistani-escorts",
  "/dubai-bur-dubai/female/indian-nationality-escorts",
  "/dubai-bur-dubai/female/pakistani-escorts",
  "/dubai/female/latvian-escorts",
  "/dubai/female/african-caribbean-escorts",
  "/dubai-al-barsha/transgender/bdsm",
  "/dubai-deira/male/african-caribbean-escorts",
  "/dubai-deira/female/egyptian-escorts",
  "/dubai-al-barsha/male/filipino-escorts",
  "/dubai/female/arabic-escorts",
  "/dubai/female/japanese-escorts",
]);

/**
 * P-2 of the first PDF: district+category URLs with GSC traffic that automatic
 * canonical logic must skip. District-only pages are protected by route shape
 * and therefore do not belong in this list.
 */
export const P2_AUTO_CANONICAL_EXCLUDED_PATHS = Object.freeze([
  "/dubai-deira/female/egyptian-escorts",
  "/dubai-bur-dubai/female/indian-nationality-escorts",
  "/dubai-al-barsha/male/filipino-escorts",
  "/dubai-sharjah/female/pakistani-escorts",
  "/dubai-bur-dubai/female/pakistani-escorts",
  "/dubai-deira/male/african-caribbean-escorts",
]);

/**
 * P-4 of the first PDF: exact server-side 301 redirects.
 * Keys are source URLs; values are target paths on the canonical host.
 */
export const SEO_REDIRECTS = Object.freeze({
  "/abu-dhabi/female/com": "/abu-dhabi/female",
  "/dubai/female/com": "/dubai/female",
  "/dubai/male/com": "/dubai/male",
});

/**
 * Legacy catalog URL without a city: /{gender}/{slug}.
 * Permanently redirected to /dubai/{gender}/{slug}.
 */
export const CITYLESS_CATALOG_PATH_PATTERN =
  /^\/(female|male|transgender|shemale)\/([^/]+)$/;

export const CITYLESS_CATALOG_DEFAULT_CITY = "dubai";

export const SPAM_PROFILE_NAME_PATTERNS = Object.freeze([
  /(^|[^a-z0-9])test\d*(?=$|[^a-z0-9])/i,
  /\.(com|net|org|info|biz|io|co|me|ru|ae|xyz|site|online|top|club|live|link|app)(?![a-z])/i,
  /http|www|\/\//i,
  /\d{7,}/,
  /@/,
]);
